import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, ToastController, ModalController, LoadingController, IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EditorHtmlPage } from '../../editor-html/editor-html.page';
import { GrupoAddReuniaoPage } from '../grupo-add-reuniao/grupo-add-reuniao.page';
import { GrupoAdmImagemPage } from '../grupo-adm-imagem/grupo-adm-imagem.page';
import { GrupoCheckListPage } from '../grupo-check-list/grupo-check-list.page';
import { GrupoGerenciarEsporadicoPage } from '../grupo-gerenciar-esporadico/grupo-gerenciar-esporadico.page';
import { GrupoParticipantesPresencaPage } from '../grupo-participantes-presenca/grupo-participantes-presenca.page';
import { GrupoResumoPage } from '../grupo-resumo/grupo-resumo.page';
import { GrupoVisitantesPresencaPage } from '../grupo-visitantes-presenca/grupo-visitantes-presenca.page';
import { GrupoProvider } from 'src/app/services/grupo/grupo';
import { UserProvider } from 'src/app/services/user/user';
import { format, parseISO } from 'date-fns';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { AlertController } from "@ionic/angular/standalone";

@Component({
  selector: 'app-grupo-gerenciar',
  templateUrl: './grupo-gerenciar.page.html',
  styleUrls: ['./grupo-gerenciar.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule
  ],
})
export class GrupoGerenciarPage implements OnInit {
  reuniao: any = {};
  idGrupo: string = "";
  readOnly: boolean = false;
  config: boolean;
  tipo: string;
  public dataAtual: any = format(new Date(), 'yyyy-MM-dd');
  resumoData: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public grupoProvider: GrupoProvider,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public userProvider: UserProvider,
    private translate: TranslateService,
    private loadingController: LoadingController,
    private alertCtrl: AlertController
  ) {
    this.reuniao = this.navParams.get('reuniao');
    this.idGrupo = this.navParams.get('idGrupo');
    this.readOnly = this.navParams.get('readOnly');
    this.tipo = this.navParams.get('tipo');

    var d = format(parseISO(this.dataAtual), "yyyy-MM-dd HH:mm:ss");
    if (this.userProvider.hasConfig('181')) {
      if (this.reuniao.dataInicio <= d) {
        this.resumoData = true;
      }
    } else {
      this.resumoData = true;
    }
    this.getConfiguracao(this.tipo);
  }

  ngOnInit() {
  }

  public closeModal() {
    this.modalCtrl.dismiss(true);
  }

  async presencaParticipantes(idReuniao: any) {
    const data = { idReuniao: idReuniao, readOnly: this.readOnly };
    const modalPage = await this.modalCtrl.create({ component: GrupoParticipantesPresencaPage, componentProps: data });
    modalPage.present();
  }

  async presencaVisitantes(idReuniao: any) {
    const data = { idReuniao: idReuniao, readOnly: this.readOnly };
    const modalPage = await this.modalCtrl.create({ component: GrupoVisitantesPresencaPage, componentProps: data });
    modalPage.present();
  }

  async resumo(idReuniao: any) {
    const data = { idReuniao: idReuniao, readOnly: this.readOnly };
    const modalPage = await this.modalCtrl.create({ component: GrupoResumoPage, componentProps: data });
    modalPage.present();
  }

  async editarReuniao(idReuniao: any) {
    const data = { idGrupo: this.idGrupo, idReuniao: idReuniao, readOnly: this.readOnly };
    const modalPage = await this.modalCtrl.create({ component: GrupoAddReuniaoPage, componentProps: data });
    modalPage.present();
  }

  async editarPauta(idReuniao: any) {
    this.grupoProvider.getPauta(idReuniao).subscribe(async (data) => {
      const pauta = { html: data, titulo: this.translate.instant("Pauta"), readOnly: this.readOnly };
      const modalPage = await this.modalCtrl.create({ component: EditorHtmlPage, componentProps: pauta });
      modalPage.present();

      (await modalPage.onWillDismiss()).data;
      if (data !== false) {
        this.grupoProvider.savePauta(idReuniao, data).subscribe((result) => {});
      }
    });
  }

  async addFoto(id: any) {
    const data = { idGrupo: id, readOnly: this.readOnly };
    const modalPage = await this.modalCtrl.create({ component: GrupoAdmImagemPage, componentProps: data });
    modalPage.present();
  }

  async visitanteEsporadico(idReuniao: any) {
    const data = { idReuniao: idReuniao, readOnly: this.readOnly, idGrupo: this.idGrupo };
    const modalPage = await this.modalCtrl.create({ component: GrupoGerenciarEsporadicoPage, componentProps: data });
    modalPage.present();
  }

  async check(idReuniao: any) {
    const data = { idReuniao: idReuniao };
    const modalPage = await this.modalCtrl.create({ component: GrupoCheckListPage, componentProps: data });
    modalPage.present();
  }

  async excluir(idReuniao: any) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Confirmar exclusão?"),
      buttons: [
        {
          text: this.translate.instant("Cancelar"),
          role: "cancel",
        },
        {
          text: this.translate.instant("Excluir"),
          handler: () => {
            this.grupoProvider.excluirReuniao(idReuniao).subscribe(async () => {
              const toast = await this.toastCtrl.create({
                message: this.translate.instant("Reunião excluida com sucesso!"),
                duration: 3000,
              });
              toast.present();
              this.modalCtrl.dismiss();
            });
          },
        },
      ],
    });
    alert.present();
  }

  getConfiguracao(tipo: string): void {
    const configMap: Record<string, string> = {
      'ministerio': '246',
      'ebd': '247',
    };

    const configKey = configMap[tipo] || '243';
    this.config = this.userProvider.hasConfig(configKey);
  }
}
